import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDaN37qj7QBWN3Ro98KOrhPk5i8rKVnWx8",
  authDomain: "auth.mypetdex.app",
  projectId: "mypetdex-c4315",
  storageBucket: "mypetdex-c4315.firebasestorage.app",
  messagingSenderId: "209772699227",
  appId: "1:209772699227:web:68d547574d8d068f6da97e"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const OAUTH_PENDING_KEY = "oauthRedirectPending";
export const OAUTH_RETURN_SCREEN_KEY = "oauthReturnScreen";

export { GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult };

/** Popup OAuth — required for Safari + auth.mypetdex.app (redirect breaks getRedirectResult). */
export function signInWithGooglePopup() {
  return signInWithPopup(auth, new GoogleAuthProvider());
}

export function signInWithApplePopup() {
  const provider = new OAuthProvider("apple.com");
  provider.addScope("email");
  provider.addScope("name");
  return signInWithPopup(auth, provider);
}

export const db = getFirestore(app);

// ─── Firebase Cloud Messaging ─────────────────────────────────────────────────
export const messaging = getMessaging(app);
export const VAPID_KEY = "BFHtEOVA_DVIs-vsMUkh3M3t4CPWoj7xLjRE1LazwCA4zlPB_qWpHzhHmxJ_0x5-Mg1bUyI1nLPsE05YcVQCyXE";

export const requestNotificationPermission = async (userId) => {
  if (!("Notification" in window) || !("serviceWorker" in navigator)) return null;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) return null;
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      if (token && userId) {
        const { doc, updateDoc, getFirestore } = await import("firebase/firestore");
        const db = getFirestore();
        await updateDoc(doc(db, "users", userId), { fcmToken: token });
        console.log("FCM token saved:", token);
      }
      return token;
    }
  } catch (e) {
    console.error("Notification permission error:", e);
  }
  return null;
};

export { onMessage };
